import { useTranslation } from 'react-i18next';
import { useFiltersContext } from "../../contexts/FiltersContext";
import { FilterType } from "../../data/Filter";

export const PosFilter = (): any => {
    const { filterStrategies, filtersChanged, setFiltersChanged } = useFiltersContext();
    const { t } = useTranslation();

    const handleHasPos = (): void => {
        const actualValue=filterStrategies.filter(x=>x.name==FilterType.posOnly)[0].implementation.value;

        filterStrategies.filter(x=>x.name==FilterType.posOnly)[0].implementation.value=!actualValue;
        setFiltersChanged(!filtersChanged)
    }

    return (
        <div className='locker-plugin-filter-checkbox mx-auto label-font-size' >
            <label className="allign-checkbox-label">
                <input type="checkbox" data-toggle="toggle" id="posToggle" data-onstyle="outline-primary" data-offstyle="outline-secondary" className="allign-checkbox-label" name="topping" onChange={handleHasPos} checked={
                    filterStrategies.filter(x=>x.name==FilterType.posOnly)[0].implementation.value
                } />
                <span className="allign-checkbox-label">
                    {t("onlyPOSLockers")}
                </span>
            </label>
        </div>
    );
}